import { ClassKey } from "@const/class.constants";
import { HostCfgDTO } from "@dto/hostCfgResponse.dto";
import { VendorWithModelsDTO } from "@dto/vendor.dto";
import { BaseDeviceProps } from "@hostcfgs/deviceProps";
import { ValidateErrorEntity } from '@rc-component/form/es/interface';
import { FormInstance, ModalFuncProps } from "antd";
import { STOR } from '../../../data/Class';
import { Deferred } from "../../../util/Deferred";

export class HostCfgItem<DeviceProps extends BaseDeviceProps = BaseDeviceProps> extends HostCfgDTO {
  key: string;
  data: DeviceProps;
  source?: string;
}

export interface DeviceType {
  deviceType: typeof STOR[number] | ClassKey.BACKUP | ClassKey.TAPE | ClassKey.SERVERSP;
}

export interface HostCfgCommon extends DeviceType {
  onFormFinishFailed: (errorInfo: ValidateErrorEntity) => void;
  form: FormInstance<HostCfgItem<BaseDeviceProps>>;
  deferred?: Deferred<void>;
  modal?: {
    destroy: () => void;
    update: (configUpdate: ModalFuncProps) => void;
  };
}

export interface HostCfgDialogProps {
  itemToEdit?: HostCfgItem;
  common: HostCfgCommon;
  devices: HostCfgItem[];
  vendors: VendorWithModelsDTO[];
}

export enum PROTO {
  HTTP = 'http', HTTPS = 'https'
}
